import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import ListView from '@/views/modules/list_view';
import ProductItemView from '@/views/list_item/product';
import Button from '@/views/button';

var globalCh = Radio.channel('global');
var routerCh = Radio.channel('router');

var empty_tmpl = '<p class="primary">There are no Products in your account.</p>'
                + '<p>Click the button below to create your first Product.</p>'
                + '<div><button class="btn btn-primary" type="submit">Create a Product</button></div>'
;
var forbidden_tmpl = '<p class="primary">You are not allowed to view Products in this account.</p>'
                + '<p>Please ask this account’s Administrator to allow you to create, view or update Products.</p>'
;

var EmptyView = Marionette.View.extend({
    events: {
        'click button': 'handle_add_product'
    },
    handle_add_product: function() {
        globalCh.request('showCreateProductDialog');
    },
    className: 'no-products',
    template: function() {
        var active = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');
        var tmpl = active.permits(primary, 'create_product') ? empty_tmpl
                                                            : forbidden_tmpl;
        return Handlebars.compile(tmpl);
    }
});

function show_products() {
    let active = globalCh.request('active_account');
    let primary = globalCh.request('primary_account');

    globalCh.request('set_selection', {
        type: 'app',
        id: 'products'
    });

    globalCh.request('show_account_secondary_nav', { 
        selected: 'product-list'
    });

    // Fetch account counts if we're out of date. We don't want to update counts
    // because we may have updated it in the mean time.
    var counts_expires = new Date(active.counts.get('expires') || 0);
    if (Date.now() - counts_expires > 0) {
        active.counts.fetch();
    }

    var app_layout = globalCh.request('app_layout');

    let enabled = active.permits(primary, 'create_product');
    let create_button = Button.extend({
        text: 'Create New Product',
        icon: 'fa fa-plus-circle',
        primary: true,
        enabled: enabled,
        enabled_tooltip: 'Create a new Product',
        disabled_tooltip: 'You do not have the correct permissions to create a Product in this account',
        action: function() {
            globalCh.request('showCreateProductDialog');
        }
    });

    let view = new ListView({
        title: 'Products',
        request_data: {
            'filter[owner.id]': active.id,
            'page[size]': 100
        },
        empty_view: EmptyView,
        child_view: ProductItemView.extend({expandable: false}),
        create_button: create_button,
        type: 'product'
    });

    app_layout.showChildView('container', view);

    routerCh.request('set_location', 'products', active);
}

export default show_products;

